// Onboarding is frontend-only by design: `users.is_profile_complete` exists
// end-to-end in the backend but is set true for every student at creation
// time (see server/controllers/authController.js/studentController.js) —
// it does not track "has this student seen the product tour," and changing
// its meaning would be a backend-semantics change out of scope for a UI
// foundation pass. Persisted per-user (not globally) in localStorage so a
// shared/admin-reset device doesn't wrongly skip a different student's tour.

const KEY_PREFIX = 'zaptude_onboarded_';

export const hasCompletedOnboarding = (userId) => {
  if (!userId) return true; // never block rendering on a missing id
  try { return localStorage.getItem(KEY_PREFIX + userId) === '1'; } catch { return true; }
};

export const markOnboardingComplete = (userId) => {
  if (!userId) return;
  try { localStorage.setItem(KEY_PREFIX + userId, '1'); } catch { /* ignore */ }
};

// Honest heuristic for "genuinely new student" — never just "hasn't seen the
// tour yet" (that would also fire for a returning student who cleared
// localStorage). Requires BOTH: the tour not yet marked complete for this
// user, AND real evidence of a fresh account (no tests taken yet OR
// readiness not yet available). Backed by fields already returned from
// GET /portal/dashboard — no new backend data needed.
export const isGenuinelyNewStudent = (dashboard) => {
  const testsTaken = dashboard?.overallStats?.tests_taken ?? 0;
  const readinessAvailable = !!dashboard?.readiness?.available;
  return testsTaken === 0 && !readinessAvailable;
};
